import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(localStorage.getItem('admin-theme') || 'light');

    useEffect(() => {
        localStorage.setItem('admin-theme', theme);
        // We apply the theme class to index.html's root or body to affect global admin styles
        if (theme === 'dark') {
            document.documentElement.classList.add('admin-dark-mode');
        } else {
            document.documentElement.classList.remove('admin-dark-mode');
        }
    }, [theme]);

    const toggleTheme = () => {
        setTheme(prev => prev === 'light' ? 'dark' : 'light');
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};
